import { GetterTree } from 'vuex'
import { RootState } from '@/store/types'
import { PuntosPeligroState } from '@/store/modules/puntos-peligro/types'
import { puntosPeligro } from '.'

export const getters: GetterTree<PuntosPeligroState, RootState> = {
  getPuntosPeligro (state: PuntosPeligroState) {
    return state
  },
  defaultMarker (state: PuntosPeligroState) {
    return state.punto_peligro_list.filter((puntosPeligro) => puntosPeligro.init)[0].id.toString()
  }
}
